import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=011bc67b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=011bc67b&lang=scss&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=011bc67b&lang=scss"
import style2 from "./Header.vue?vue&type=style&index=2&id=011bc67b&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011bc67b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011bc67b')) {
      api.createRecord('011bc67b', component.options)
    } else {
      api.reload('011bc67b', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=011bc67b&scoped=true", function () {
      api.rerender('011bc67b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/Header.vue"
export default component.exports